import { FC } from 'react';
import { createZodFormResolver, Form, lt } from '@mews/framework';
import { SchemaFormFields } from '@mews-commander/form';
import { useCommanderSelector } from '@mews-commander/utils';
import { TextKey } from '@mews-commander/enums';
import { FormLayout } from '../../FormLayout';
import { getReservationPurposeFormInitialValues } from '../selectors';
import { ReservationPurposeFormSchema, ReservationPurposeFormValues } from './types';
import { useChangeReservationPurposeMutation } from './useChangeReservationPurposeMutation';

interface ReservationPurposeFormProps {
    reservationIds: string[];
    scope: string;
    availabilityBlockId?: string | null;
    onSuccess?: () => void;
}

export const ReservationPurposeForm: FC<ReservationPurposeFormProps> = ({
    availabilityBlockId,
    reservationIds,
    scope,
    onSuccess,
}) => {
    const defaultValues = useCommanderSelector((state) => getReservationPurposeFormInitialValues(state, { scope }));
    const mutation = useChangeReservationPurposeMutation(reservationIds);

    const onSubmit = (values: ReservationPurposeFormValues) => {
        mutation.mutate(values, { onSuccess });
    };

    return (
        <Form
            onSubmit={onSubmit}
            resolver={createZodFormResolver(ReservationPurposeFormSchema)}
            values={defaultValues}
            dataTestForm={`reservation-purpose-form-${scope}`}
        >
            <FormLayout loading={mutation.isPending} submitButtonDisabled={!!availabilityBlockId} vertical={false}>
                <SchemaFormFields
                    schema={ReservationPurposeFormSchema}
                    formDefinition={{
                        fields: {
                            reservationPurpose: {
                                label: lt(TextKey.ReservationPurpose),
                                field: {
                                    type: 'enum',
                                    enumPrefix: 'ReservationPurpose',
                                    emptyValueAsNull: true,
                                },
                                disabled: !!availabilityBlockId,
                            },
                        },
                    }}
                />
            </FormLayout>
        </Form>
    );
};
